import _ from 'lodash';

function FileModel(data) {
  data = data || {};

  return _.defaults(data, {
    workspace: 'root',
    category: 'files',
    disk: 'local',
    folder: '/files',
    overwrite: 'false',
    isSave: 'true',
  });
}

export default FileModel;
